var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _ellipse3, _mask, _g, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetriDishLbAmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 29,
    viewBox: "0 -20 101 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.359434 8.92702C0.359435 4.1975 22.8676 0.363458 50.6328 0.36346C78.3981 0.363463 100.906 4.1975 100.906 8.92703C100.906 11.7461 100.906 12.5625 100.906 12.5625C99.1166 5.6956 61.8484 4.16051 50.6328 4.16051C39.4173 4.16051 1.82377 5.21075 0.359434 12.5625C0.359434 12.5625 0.359434 11.7461 0.359434 8.92702Z",
    fill: "#668BA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1.00004 9.43155C1.00004 4.77479 23.1619 0.999735 50.5 0.999738C77.8381 0.99974 100 4.7748 100 9.43156C100 12.2073 100 20.6475 100 20.6475C98.2379 13.8862 61.543 12.3747 50.5 12.3747C39.457 12.3747 2.44185 13.4088 1.00004 20.6475C1.00004 20.6475 1.00004 12.2072 1.00004 9.43155Z",
    fill: "#668BA6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4999,
    cy: 20.5685,
    rx: 49.4999,
    ry: 8.43182,
    fill: "#CCD8E1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4999,
    cy: 20.5685,
    rx: 49.4999,
    ry: 8.43182,
    fill: "#FCE19D",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M99.9999 20.5684C99.9999 25.2252 77.838 29.0003 50.5 29.0003C23.1619 29.0003 1.00005 25.2252 1.00005 20.5684C1.00005 17.7927 1 9.35254 1 9.35254C2.76213 16.1138 39.457 17.9434 50.5 17.9434C61.543 17.9434 98.5581 16.5912 99.9999 9.35254C99.9999 9.35254 99.9999 17.7927 99.9999 20.5684Z",
    fill: "#99B2C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5918 18.5C27.5918 18.5 38.9656 19.4545 50.3393 19.4545C61.7131 19.4545 73.0869 18.5 73.0869 18.5V26.7727C73.0869 26.7727 59.15 27.7273 50.3393 27.7273C41.5287 27.7273 27.5918 26.7727 27.5918 26.7727V18.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M100.906 12.4812C100.906 17.2107 78.398 21.0447 50.6328 21.0447C22.8676 21.0447 0.359425 17.2107 0.359425 12.4812C0.359425 9.6621 0.359375 8.8457 0.359375 8.8457C2.14904 15.7126 39.4172 17.5708 50.6328 17.5708C61.8484 17.5708 99.4419 16.1974 100.906 8.8457C100.906 8.8457 100.906 9.6621 100.906 12.4812Z",
    fill: "#99B2C4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 50.6327,
    cy: 8.92684,
    rx: 50.2734,
    ry: 8.56356,
    fill: "#99B2C4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 18
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 50.6328,
    cy: 9.2452,
    rx: 50.2734,
    ry: 8.56356,
    fill: "#99B2C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.1882 21.6862L84.3106 1.16593L75.5249 -0.93457L4.26367 19.9088L14.1882 21.6862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.5293 -0.449219L11.4227 15.87L8.49414 14.9006L62.5095 -0.449219H68.5293Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7285 25.2268H43.2487V24.4765H41.5936V21.3323H40.7285V25.2268Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7134 25.2268H45.4089C46.3258 25.2268 46.741 24.8889 46.741 24.1329C46.741 23.6232 46.5507 23.3196 46.0778 23.1879V23.1764C46.4585 23.0447 46.6142 22.7755 46.6142 22.346C46.6142 21.6473 46.2105 21.3323 45.2878 21.3323H43.7134V25.2268ZM44.5784 22.8844V22.0596H45.2013C45.6223 22.0596 45.7607 22.157 45.7607 22.4663C45.7607 22.7813 45.6107 22.8844 45.1551 22.8844H44.5784ZM44.5784 24.4994V23.6117H45.1897C45.703 23.6117 45.876 23.7263 45.876 24.0642C45.876 24.3906 45.7203 24.4994 45.2589 24.4994H44.5784Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9248 26.0286H47.6687L49.6007 21.0459H48.8567L46.9248 26.0286Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5727 25.2955C50.9706 25.2955 51.2705 25.1466 51.4781 24.8545L51.5069 25.2268H52.2278V23.3024C52.2278 22.5235 51.8356 22.1684 50.9821 22.1684C50.1517 22.1684 49.748 22.5064 49.7019 23.1707H50.5265C50.5381 22.9645 50.6534 22.8328 50.9475 22.8328C51.2532 22.8328 51.3743 22.9817 51.3743 23.291V23.3884H50.8206C50.019 23.3884 49.6211 23.7377 49.6211 24.3677C49.6211 24.9634 49.9787 25.2955 50.5727 25.2955ZM50.8322 24.6312C50.59 24.6312 50.4631 24.5166 50.4631 24.299C50.4631 24.0814 50.59 23.9496 50.9764 23.9496H51.3743V24.2933C51.2532 24.5166 51.0744 24.6312 50.8322 24.6312Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9256 25.2268H53.7791V23.3082C53.9117 23.0218 54.0789 22.9015 54.2808 22.9015C54.4884 22.9015 54.6095 23.0218 54.6095 23.2853V25.2268H55.463V23.3082C55.6014 23.0218 55.7629 22.9015 55.9705 22.9015C56.1781 22.9015 56.2935 23.0218 56.2935 23.2853V25.2268H57.147V23.1936C57.147 22.5235 56.8067 22.1684 56.1954 22.1684C55.8436 22.1684 55.5668 22.2887 55.3362 22.5923C55.1862 22.3116 54.9152 22.1684 54.5288 22.1684C54.1597 22.1684 53.8944 22.3002 53.6753 22.6037L53.6522 22.2372H52.9256V25.2268Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8647 26.2692H58.7182V24.9863C58.92 25.1982 59.1738 25.2955 59.4967 25.2955C60.183 25.2955 60.5694 24.8717 60.5694 24.0642V23.3941C60.5694 22.5865 60.183 22.1684 59.4967 22.1684C59.1161 22.1684 58.8393 22.3002 58.6144 22.598L58.5913 22.2372H57.8647V26.2692ZM59.3006 24.6083C59.0296 24.6083 58.8393 24.4536 58.7182 24.1501V23.3082C58.8393 23.0104 59.0296 22.8557 59.2949 22.8557C59.5717 22.8557 59.7159 23.0161 59.7159 23.3998V24.0642C59.7159 24.4536 59.5717 24.6083 59.3006 24.6083Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetriDishLbAmp);
export default __webpack_public_path__ + "static/media/petri-dish-lb-amp.dc7bc7e5ab67c81cbb9b84d639683d01.svg";
export { ForwardRef as ReactComponent };